// extracted by mini-css-extract-plugin
export var active = "_m6-e";
export var blink = "_m6-f";
export var dropDownSelector = "_m6-5";
export var dropDownWrapper = "_m6-4";
export var fakeCursor = "_m6-d";
export var fontSizeButton = "_m6-7";
export var formQuillEditor = "_m6-0";
export var pressed = "_m6-g";
export var qlBlank = "_m6-1";
export var textFormattingToolbar = "_m6-2";
export var textFormattingToolbarClosed = "_m6-3";
export var textFormattingToolbarInline = "_m6-6";
export var textToolbarOption = "_m6-8";
export var toolbarCell = "_m6-a";
export var toolbarCellCollapsed = "_m6-b";
export var toolbarOptionHitArea = "_m6-c";
export var toolbarOverflow = "_m6-9";